module.exports = __webpack_public_path__ + "img/Old_FuWu.a0a5acf8.png";